"use client"

import * as React from "react"
import { cn } from '../../../../lib/utils'
import { gridEmptyVariants } from "../constants"
import type { GridEmptyProps } from "../types"

const GridEmpty = React.forwardRef<HTMLDivElement, GridEmptyProps>(
  ({ className, children, icon, title, description, ...props }, ref) => {
    return (
      <div ref={ref} className={cn(gridEmptyVariants(), className)} {...props}>
        {children || (
          <>
            {icon && (
              <div className="mb-4 text-muted-foreground/50">{icon}</div>
            )}
            {title && (
              <h3 className="text-lg font-semibold text-foreground">{title}</h3>
            )}
            {description && (
              <p className="mt-2 text-sm text-muted-foreground max-w-md">
                {description}
              </p>
            )}
            {!icon && !title && !description && <p>No items to display</p>}
          </>
        )}
      </div>
    )
  }
)

GridEmpty.displayName = "GridEmpty"

export { GridEmpty }
